import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import type { RouterContext } from '@/app/router';
import { SessionWatcher } from '@/app/session-watcher';

/** 개발 중에만 라우터·쿼리 개발 도구를 띄운다 (운영 번들에서 빠진다) */
const Devtools = import.meta.env.DEV
  ? lazy(async () => {
      const [{ TanStackRouterDevtools }, { ReactQueryDevtools }] = await Promise.all([
        import('@tanstack/react-router-devtools'),
        import('@tanstack/react-query-devtools'),
      ]);
      return {
        default: () => (
          <>
            <TanStackRouterDevtools position='bottom-right' />
            <ReactQueryDevtools buttonPosition='bottom-left' />
          </>
        ),
      };
    })
  : () => null;

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({ meta: [{ title: '팬즈드롭 코인 충전' }] }),
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <HeadContent />
      <SessionWatcher />
      <Outlet />
      <Suspense>
        <Devtools />
      </Suspense>
    </>
  );
}
